export { mobileBackContainerHTML, mobileChevronHTML } from './htmlSnippets'
export {
  insertBannerHTML,
  insertTbybHTML,
  insertFeaturedContent,
  getInsertedAccountElements,
  insertMyAccountHTML,
  insertSignInHTML,
  insertCartItemCount,
  insertNavLinkHTML,
  insertMobileDiscountLine,
} from './insertHTML'
export {
  getCurrentLevelFromMenuClick,
  getCurrentLevelFromBackClick,
} from './mobileMenuLevels'
export { openOverlay as openOverlay, closeOverlay } from './overlay'
export {
  makeInvisible,
  makeVisible,
  setDisplayBlock,
  setDisplayFlex,
  setDisplayNone,
  transformTranslate,
  setPosRelative,
  setPosSticky,
  setPosUnset,
  setTransition,
  setTextAlignLeft,
  setTextAlignCenter,
  setWidth,
  setWhiteSpace,
  isVisible,
  getDesktopNavbarHeight,
  getMobileNavbarHeight,
} from './styles'
